import { useEffect } from 'react';
import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { CssBaseline, ThemeProvider } from '@material-ui/core';

import { RTL } from './components/rtl';
import routes from './routes';
import { createCustomTheme } from './theme';
import { selectAuth, checkAuth } from './features/auth/authSlice';
import { useAppSelector, useAppDispatch } from './hooks/useStore';
import { fetchGeneraleParams } from './features/app/appSlice';
import i18n from './i18n';

export const App: FC = () => {
  const content = useRoutes(routes);
  const { isInitialized } = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // check user authentication
    dispatch(checkAuth());

    // fetch generale params
    dispatch(fetchGeneraleParams());
  }, []);

  const theme = createCustomTheme({
    direction: 'ltr',
    theme: 'light'
  });

  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <RTL direction="ltr">
          <CssBaseline />
          {isInitialized && content}
        </RTL>
      </I18nextProvider>
    </ThemeProvider>
  );
};
